import {postImplementImage} from "src/scripts/mixin";
import {highlight_start} from "./highlight";
export const postRenderFunctions = () => {
 
    midscreen();
    lowscreen();
    setCurrentAndPast(document.body.scrollTop);
    setTextAndImages(document.body.scrollTop);
    
    // console.log("run post render");
    
    const scrollFunction = () => {  
        document.getElementById("log_scrollTop").innerHTML = scrollY;
        setCurrentAndPast(scrollY);
        setTextAndImages(scrollY);
        
        let setLineHeight = scrollY;
        let currentSelectorParent = document.querySelector(".vertical.scroll_current");
        if(currentSelectorParent) {
            let currentSelector = currentSelectorParent.querySelector(".vline");
            
            let scrollStart = currentSelectorParent.dataset.offsetdocumenttop;
            let scrollSet = scrollY - scrollStart + window.midscreen;
            let maxheight = currentSelectorParent.dataset.height-7;
            // console.log(scrollStart, scrollSet);
            // let _100 = false;
        
            if(scrollSet <= maxheight){
                currentSelector.style.height = scrollSet + "px";
            }
            else {
                currentSelector.style.height = "100%";
                // _100 = true;
            }
            
            document.getElementById("scrollstate").innerHTML = "currheight:"+currentSelectorParent.offsetHeight;
            document.getElementById("scrollstate2").innerHTML = "scrollset:"+scrollSet;
            document.getElementById("scrollstate3").innerHTML = "scrollStart:"+scrollStart;
            document.getElementById("scrollstate4").innerHTML = "maxheight:"+maxheight;
            // document.getElementById("scrollstate5").innerHTML = "100?:"+_100;
            
            document.getElementById("redline").style.top = parseInt(scrollY) + window.midscreen + "px";
            document.getElementById("blueline").style.top = parseInt(scrollY) + window.lowscreen + "px";
            
            // console.log(window.lowscreen)
        }
    }
    
    window.addEventListener("scroll", scrollFunction, false);
    
    window.scrollFunction = scrollFunction();
    
    setElementsHeightAndPosition();

    window.addEventListener("resize", () => {
        setElementsHeightAndPosition();
        midscreen();
        lowscreen();
    }, false);
    
    postImplementImage(() => {
        updateElementsHeightAndPosition();
    });
    
    // document.querySelectorAll(".navigation__button").forEach( elm => {
    //     elm.addEventListener("click", (me) => {
            
    //         // console.log("eachClick")
          
            
    //     }, false)
    // })
    
    
}

const midscreen = () => {
    
    window.midscreen = window.innerHeight *0.6;
    // document.getElementById("log_midscreen").innerHTML = window.midscreen;
    
}
const lowscreen = () => {
    
    window.lowscreen = window.innerHeight*0.7;
    // document.getElementById("log_midscreen").innerHTML = window.midscreen;
    
}

const setTextAndImages = (scrollY) => {
    
    let currentScrollState = scrollY + window.lowscreen; 
    
    document.querySelectorAll(".highlight__textcontent, .highlight__imagecontent").forEach(me => {
        let elementTop = me.getBoundingClientRect().top + document.documentElement.scrollTop;
        let elementBottom = elementTop + me.offsetHeight;
        
        
        if(currentScrollState >= elementTop && currentScrollState < elementBottom) {
            me.classList.add("active");
        }
        else if(currentScrollState >= elementBottom){
            me.classList.add("active");
        }
        else if(currentScrollState <= elementBottom) {
            me.classList.remove("active");
        }
        
    });
    
}
export const setCurrentAndPast = (scrollY) => {
    
    let currentScrollState = scrollY + window.midscreen;
    
    document.querySelectorAll(".vertical").forEach(me => {
        
        let elementTop = me.getBoundingClientRect().top + document.documentElement.scrollTop;
        let elementBottom = elementTop + me.offsetHeight;
        
        if(currentScrollState >= elementTop && currentScrollState < elementBottom) {
            me.classList.remove("scroll_past");
            // me.style.height = "10px";
            me.classList.add("scroll_current");
        }
        else if(currentScrollState >= elementBottom){
            me.classList.remove("scroll_current");
            me.classList.add("scroll_past");
            // me.style.height = "1000px";
            // console.log("add past")
            me.querySelector(".vline").style.height = "100%";
        }
        else if(currentScrollState <= elementBottom) {
            me.classList.remove("scroll_current");
            me.classList.remove("scroll_past");
            // me.style.height = "100px";
            me.querySelector(".vline").style.height = "0";
        }
        
    });
    
    document.querySelectorAll(".spin").forEach(me => {
       
        let elementTop = me.getBoundingClientRect().top + document.documentElement.scrollTop + 25;
        let elementBottom = elementTop + me.offsetHeight;
        
        if(currentScrollState >= elementTop && currentScrollState < elementBottom) {
            me.classList.add("active");
        }
        else if(currentScrollState >= elementBottom){
            me.classList.add("active");
        }
        else if(currentScrollState <= elementBottom) {
            me.classList.remove("active");
        }
        
    });
    
    document.querySelectorAll(".horizon").forEach(me => {
      
        let elementTop = me.getBoundingClientRect().top + document.documentElement.scrollTop + 25;
        let elementBottom = elementTop + me.offsetHeight;
        
        if(currentScrollState >= elementTop && currentScrollState < elementBottom) {
            me.classList.add("active");
        }
        else if(currentScrollState >= elementBottom){
            me.classList.add("active");
        }
        else if(currentScrollState <= elementBottom) {
            me.classList.remove("active");
        }
        
    });
    
}

const setElementsHeightAndPosition = () => {
    document.querySelectorAll(".vertical").forEach(me => {
    
        let offsetdocumenttop = me.getBoundingClientRect().top + document.documentElement.scrollTop
        let elementHeight = me.offsetHeight;
    
        me.dataset.offsetdocumenttop = offsetdocumenttop;
        me.dataset.offsetdocumentbottom = offsetdocumenttop + elementHeight;

        me.dataset.height = elementHeight;
        
        // console.warn("container-height", elementHeight);
        
        me.style.height = elementHeight + "px";
        
        
    });
}

export const updateElementsHeightAndPosition = () => {
    setElementsHeightAndPosition();
}